import request from '@/utils/request'

// 公告分类查询
export function getCate (currentPage,size) {
  return request({
    url: `/index/newsClass/list`,
    method: 'get',
    params: {currentPage: currentPage, size: size}
  })
}



// WEBPACK FOOTER //
// ./src/api/newsCate.js